import { Component, EventEmitter, Input, OnInit, Output,Inject, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
// import { GetArticlesService } from 'src/app/services/get-articles.service';
import { MainBodyService } from 'src/app/services/main-body.service';
import { themeData } from 'src/interface/themesetting';

@Component({
  selector: 'app-article-keyword-filter',
  templateUrl: './article-keyword-filter.component.html',
  styleUrls: ['./article-keyword-filter.component.scss']
})
export class ArticleKeywordFilterComponent implements OnInit {
  showkeywords = false;
  isChevronUp = [true, true, true, true, true, true];
  @Input () journal_id:string;
  themeSettingsData: themeData
  subscriptions: Subscription[] = [];
  allKeywords:string[]=[];
  keywordsByFirstLetter: string[] = [];
  @Output() special_issue_emit = new EventEmitter<boolean>();
  @Input() special_issue:boolean;
  @Output() sort_criteria_emit = new EventEmitter<string>();
  @Output() keyword_show = new EventEmitter<boolean>();
  sortCriteria: string;
  constructor(public mainBodyService: MainBodyService
    ,@Inject(PLATFORM_ID) private platformId: any) {

  }

  ngOnInit() {

    if (this.journal_id) {
      const themeSub = this.mainBodyService.getAllThemeSettings(this.journal_id).subscribe((result) => {
        if (result.data) {
          this.themeSettingsData = result.data;
          const color = this.themeSettingsData.theme_colors;
          if (isPlatformBrowser(this.platformId)) {
          Object.entries(color).map(([key, value]) => {
            const element = "--" + key;
            const val = value;
            document.documentElement.style.setProperty(element, val);
          });
        }
        }
      });
      this.subscriptions.push(themeSub);
    }

  }

  showKeywordDiv() {
    this.showkeywords = !this.showkeywords;
    this.keyword_show.emit(this.showkeywords);
  }
  specialIssueChange(event: Event) {
    this.special_issue = (event.target as HTMLInputElement).checked;
    this.special_issue_emit.emit(this.special_issue);
  }

  toggleSort(sortField: string, i: number) {
    this.isChevronUp[i] = !this.isChevronUp[i];
    this.isChevronUp.fill(true, 0, i);
    const sortBy = this.isChevronUp[i] ? 'ASC' : 'DESC';
    this.sortCriteria = sortField + ':' + sortBy;
    this.sort_criteria_emit.emit(this.sortCriteria);
  }


}
